/* CPIS Searchanise — badges auténticos Shopify (v2)
 * Renderiza las etiquetas Label:, Label2: y Label3: presentes en el producto.
 * Soporta tarjetas re-renderizadas por filtros y paginación infinita.
 * No cambia precios, filtros ni el orden y consulta solo las tarjetas visibles.
 */
(function () {
  'use strict';
  if (window.__cpisSearchaniseBadgesV2) return;
  window.__cpisSearchaniseBadgesV2 = true;

  var root = null;
  var mutationObserver = null;
  var bootObserver = null;
  var visibilityObserver = null;
  var productCache = Object.create(null);
  var queued = [];
  var active = 0;
  var maxConcurrent = 2;
  var scanQueued = false;
  var requestCount = 0;
  var maxRequests = 120;

  function text(value) { return String(value == null ? '' : value).trim(); }

  function classify(value) {
    var v = text(value).toLowerCase();
    if (v === 'top 10' || v === 'top10') return 'top10';
    if (v.indexOf('más vendido') !== -1 || v.indexOf('mas vendido') !== -1) return 'mas-vendido';
    if (v === 'nuevo' || v === 'nueva' || v === 'novedad') return 'nuevo';
    if (v === 'recomendado' || v === 'recomendada' || v === 'recomendados' || v === 'recomendados por carbone' || v === 'recomendado por carbone' || v === 'recomendados carbone' || v === 'recomendado carbone') return 'recomendados';
    if (v.indexOf('precio especial') !== -1 || v.indexOf('oferta especial') !== -1) return 'precio-especial';
    if (v === 'proximamente' || v === 'próximamente') return 'proximamente';
    return 'general';
  }

/* CPIS: context badges and product label fallback.
   Un producto de la colección Nuevos es legítimamente Nuevo;
   un recomendado se identifica únicamente dentro de la selección editorial.
   Se siguen leyendo Label:/Label2:/Label3: desde el producto. */
  function collectionBadges() {
    var p = location.pathname.split('/').filter(Boolean);
    var handle = p[0] === 'collections' ? p[1] : '';
    if (handle === 'lo-nuevo-en-carbone' || handle === 'productos-nuevos') {
      return [{ text: 'Nuevo', kind: 'nuevo' }];
    }
    if (handle === 'recomendados-por-carbone') {
      return [{ text: 'Recomendados Carbone', kind: 'recomendados' }];
    }
    return [];
  }

  function mergeLabels(explicit, context) {
    var result = [];
    context.concat(explicit).forEach(function (label) {
      if (!label || !label.text) return;
      if (result.some(function (other) { return other.kind === label.kind && other.kind !== 'general'; })) return;
      if (result.some(function (other) { return other.text.toLowerCase() === label.text.toLowerCase(); })) return;
      if (result.length < 3) result.push(label);
    });
    return result;
  }

  /* Lectura rápida de etiquetas públicas ya verificadas por Liquid.
     Evita demoras en móviles; Searchanise puede inyectar productos luego. */
  var hydratedMap;
  function getServerLabels(handle) {
    if (!hydratedMap) {
      hydratedMap = Object.create(null);
      var el = document.getElementById('cpis-curated-label-map');
      if (el) {
        try {
          var raw = JSON.parse(el.textContent || '{}');
          Object.keys(raw).forEach(function (key) {
            if (Array.isArray(raw[key])) {
              hydratedMap[key] = raw[key].map(function (value) {
                var kind = classify(value);
                var label = kind === 'proximamente' ? 'Próximamente' : kind === 'recomendados' ? 'Recomendados Carbone' : value;
                return {text:label, kind:kind};
              });
            }
          });
        } catch (e) {
          /* El render en CSS y el endpoint Shopify siguen como respaldo. */
        }
      }
    }
    return hydratedMap[handle] || [];
  }

  function getLabels(product) {
    var tags = product && product.tags;
    if (typeof tags === 'string') tags = tags.split(',');
    if (!Array.isArray(tags)) return [];
    var labels = [];
    tags.forEach(function (tag) {
      var v = text(tag);
      var label = '';
      if (v.slice(0, 6) === 'Label:') label = v.slice(6);
      else if (v.indexOf('Label2:') !== -1) label = v.split('Label2:').pop();
      else if (v.indexOf('Label3:') !== -1) label = v.split('Label3:').pop();
      label = text(label);
      if (!label || labels.length >= 3) return;
      var kind = classify(label);
      if (kind === 'proximamente') label = 'Próximamente';
      if (kind === 'recomendados') label = 'Recomendados Carbone';
      if (!labels.some(function (l) { return l.text === label; })) labels.push({ text: label, kind: kind });
    });
    /* Precio especial solo si existe una rebaja real y verificable en la
       variante inicial disponible de Shopify. No inferir por precio de P1/P2. */
    if (!labels.some(function (l) { return l.kind === 'precio-especial'; }) && product && Array.isArray(product.variants)) {
      var chosen = product.variants.find(function (v) { return v && v.available; }) || product.variants[0];
      if (chosen && Number(chosen.compare_at_price) > Number(chosen.price) && Number(chosen.price) > 0) {
        labels.push({ text: 'Precio especial', kind: 'precio-especial' });
      }
    }
    return labels.slice(0, 3);
  }

  function handleOf(card) {
    var link = card.querySelector('a[href*="/products/"],a[data-url*="/products/"]');
    if (!link) return '';
    var href = link.getAttribute('href') || link.getAttribute('data-url') || '';
    try {
      var url = new URL(href, location.href);
      if (url.origin !== location.origin) return '';
      var result = url.pathname.match(/\/products\/([^\/?#]+)/);
      return result ? decodeURIComponent(result[1]) : '';
    } catch (e) { return ''; }
  }

  function render(card, handle, labels) {
    if (!document.documentElement.contains(card)) return;
    if (handleOf(card) !== handle) return;
    var existing = card.querySelector('.cpis-searchanise-badges');
    if (existing) existing.remove();
    if (!labels.length) return;

    var badgeBox = document.createElement('div');
    badgeBox.className = 'cpis-searchanise-badges';
    badgeBox.setAttribute('aria-label', 'Etiquetas del producto');

    labels.forEach(function (item) {
      var badge = document.createElement('span');
      badge.className = 'product-label';
      badge.setAttribute('data-cpis-badge', item.kind);
      badge.textContent = item.text;
      badgeBox.appendChild(badge);
    });

    var host = card.querySelector('.snize-item') || card;
    host.insertBefore(badgeBox, host.firstChild);
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    var onDone;
    productCache[handle] = new Promise(function (resolve) { onDone = resolve; });
    queued.push({ handle: handle, done: onDone });
    pump();
    return productCache[handle];
  }

  function pump() {
    while (active < maxConcurrent && queued.length) {
      (function (job) {
        if (requestCount >= maxRequests) {
          job.done([]);
          return;
        }
        requestCount++;
        active++;
        var prefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        prefix = prefix.charAt(prefix.length - 1) === '/' ? prefix : prefix + '/';
        fetch(prefix + 'products/' + encodeURIComponent(job.handle) + '.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (res) { if (!res.ok) throw new Error('Unavailable product'); return res.json(); })
          .then(function (product) { job.done(getLabels(product)); })
          .catch(function () { job.done([]); })
          .then(function () {
            active--;
            pump();
          });
      })(queued.shift());
    }
  }

  function inspect(card) {
    var handle = handleOf(card);
    if (!handle || !card.querySelector('.snize-title')) return;

    var oldHandle = card.getAttribute('data-cpis-badge-handle');
    if (oldHandle !== handle) {
      var oldBadge = card.querySelector('.cpis-searchanise-badges');
      if (oldBadge) oldBadge.remove();
      card.removeAttribute('data-cpis-badges-enriched');
      card.setAttribute('data-cpis-badge-handle', handle);
    }

    /* Aplicar inmediatamente la etiqueta propia de la colección: no depende
       de la latencia o disponibilidad del endpoint Shopify product.js. */
    var context = collectionBadges();
    var verifiedLabels = getServerLabels(handle);
    var instantLabels = mergeLabels(verifiedLabels, context);
    if (instantLabels.length && !card.querySelector('.cpis-searchanise-badges')) {
      render(card, handle, instantLabels);
    }

    if (card.getAttribute('data-cpis-badges-enriched') === handle) return;
    card.setAttribute('data-cpis-badges-enriched', handle);
    fetchProduct(handle).then(function (labels) {
      var finalLabels = mergeLabels(labels, instantLabels);
      if (finalLabels.length) render(card, handle, finalLabels);
    });
  }

  function observeCard(card) {
    var handle = handleOf(card);
    if (!handle || !card.querySelector('.snize-title')) return;

    /* Searchanise puede reemplazar el contenido sin sustituir el nodo.
       Restaurar de inmediato la etiqueta legítima de la colección. */
    var prior = card.getAttribute('data-cpis-badge-handle');
    if (prior && prior !== handle) {
      var obsolete = card.querySelector('.cpis-searchanise-badges');
      if (obsolete) obsolete.remove();
      card.removeAttribute('data-cpis-badges-enriched');
      card.removeAttribute('data-cpis-badge-observed');
    }
    card.setAttribute('data-cpis-badge-handle', handle);

    var ctx = mergeLabels(getServerLabels(handle), collectionBadges());
    if (ctx.length && !card.querySelector('.cpis-searchanise-badges')) {
      render(card, handle, ctx);
    }

    if (card.getAttribute('data-cpis-badge-observed') === handle) {
      if (productCache[handle] && card.getAttribute('data-cpis-badges-enriched') !== handle) {
        inspect(card);
      }
      return;
    }
    card.setAttribute('data-cpis-badge-observed', handle);
    if (visibilityObserver) visibilityObserver.observe(card);
    else inspect(card);
  }

  function scan() {
    scanQueued = false;
    if (!root) return;
    root.querySelectorAll('.snize-product').forEach(observeCard);
  }

  function schedule() {
    if (scanQueued) return;
    scanQueued = true;
    window.setTimeout(scan, 150);
  }

  function activate(host) {
    if (!host || root === host) return;
    if (mutationObserver) mutationObserver.disconnect();
    if (visibilityObserver) visibilityObserver.disconnect();
    root = host;
    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          visibilityObserver.unobserve(entry.target);
          inspect(entry.target);
        });
      }, { rootMargin: '230px 0px', threshold: 0.01 });
    }
    if ('MutationObserver' in window) {
      mutationObserver = new MutationObserver(schedule);
      mutationObserver.observe(host, { childList: true, subtree: true });
    }
    schedule();
  }

  function boot() {
    var host = document.getElementById('snize_results');
    if (host) {
      activate(host);
      return;
    }
    if (!('MutationObserver' in window)) return;
    // Searchanise suele insertar #snize_results DENTRO del catálogo,
    // no como hijo directo de body. Observar la subestructura sólo
    // hasta que aparezca el widget, para ahorrar recursos en móviles.
    bootObserver = new MutationObserver(function () {
      var current = document.getElementById('snize_results');
      if (!current) return;
      bootObserver.disconnect();
      bootObserver = null;
      activate(current);
    });
    bootObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () {
      if (bootObserver) {
        bootObserver.disconnect();
        bootObserver = null;
      }
    }, 25000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
